'use client'

import { useEffect, useRef } from "react"

interface GiggsyProps {
  core?: any | null
}

const Giggsy: React.FC<GiggsyProps> = () => {
    const chatbotLoadedRef = useRef(false)

    const loadChatbot = () => {
        if (chatbotLoadedRef.current) return
        chatbotLoadedRef.current = true

        const stylesheetId = "dialpad-chatbot-stylesheet"
        if (!document.getElementById(stylesheetId)) {
            const stylesheet = document.createElement("link")
            stylesheet.id = stylesheetId
            stylesheet.rel = "stylesheet"
            stylesheet.href = "https://us-central.dx.dialpad.com/static/common/css/koopid.css"
            document.head.appendChild(stylesheet)
        }

        const inlineScript = document.createElement("script")
        inlineScript.innerHTML = `window.dxe = {"server": "https://us-central.dx.dialpad.com" };`
        document.body.appendChild(inlineScript)

        const externalScript = document.createElement("script")
        externalScript.type = "module"
        externalScript.async = true
        externalScript.src = "https://us-central.dx.dialpad.com/dxclient/dist/dialpad-chatbot.es.js"
        document.body.appendChild(externalScript)
    }

    useEffect(() => {
        // Watch for any third-party script modifying the viewport to restrict zooming
        const fixViewport = () => {
            const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]')
            if (!meta) return
            const content = meta.getAttribute('content') ?? ''
            if (/maximum-scale=(?!5|[5-9]|\d{2})/i.test(content) || /user-scalable\s*=\s*no/i.test(content)) {
                const fixed = content
                    .replace(/,?\s*maximum-scale=[^,]*/gi, '')
                    .replace(/,?\s*user-scalable=[^,]*/gi, '')
                    .replace(/\s*,\s*/g, ', ')
                    .trim()
                meta.setAttribute('content', fixed + ', maximum-scale=5')
            }
        }

        const vpObserver = new MutationObserver(fixViewport)
        const viewportMeta = document.querySelector('meta[name="viewport"]')
        if (viewportMeta) vpObserver.observe(viewportMeta, { attributes: true, attributeFilter: ['content'] })
        vpObserver.observe(document.head, { childList: true })

        return () => {
            vpObserver.disconnect()
        }
    }, [])

    return (
        <>
        <div
            id="dx_chatbot_fab_wrapper_id"
            className="w-36 overflow-hidden fixed bottom-4 right-4 z-123"
            onClick={loadChatbot}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault()
                    loadChatbot()
                }
            }}
            role="button"
            tabIndex={0}
            aria-label="Open chat with us"
        >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
            data-dxchannelid="621a587023ce4d459531e4c5c0d037b9"
            data-dxprovemail="4915080945893376@ultrafast.co.nz"
            id="dx_chatbot_fab_id"
            alt="Chat with us"
            width={144}
            height={60}
            src="https://images.prismic.io/tuatahi-first-fibre/o_RRwkdR8zX1BW-o_dialpad-fab%401_5x.png?auto=format,compress"
            />
        </div>
        </>
    )
}

export default Giggsy
